<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <app-no-content-stub
    [icon]="'stat-class-2'"
    [text]="'classroom-news.stub'">
  </app-no-content-stub>
</ng-template>
